import React from 'react';

import cn from 'classnames';

import { ToastManager } from '@features/ToastManager';
import { Icon } from '@shared/ui';
import { EquipmentBoard } from '@widgets/equipmentBoard';
import { EquipmentHeader } from '@widgets/equipmentHeader';

import cls from './Equipment.module.css';
import { useEquipmentPage } from '../model/useEquipmentPage';

interface EquipmentProps {
    classes?: string;
}

export const Equipment = ({ classes }: EquipmentProps) => {
    const { filterValue, setFilterValue, isInitialLoading } = useEquipmentPage();

    return (
        <div className={cn(cls.Equipment, [classes])}>
            <EquipmentHeader
                filterValue={filterValue}
                isInitialLoading={isInitialLoading}
                onFilterChange={setFilterValue}
            />
            <EquipmentBoard filterValue={filterValue} isInitialLoading={isInitialLoading} />
            <ToastManager
                toastPosition="right"
                renderToast={({ isToastShow, positionStyles, text, type }) => (
                    <div
                        className={cn(cls.toastContainer, isToastShow && cls.toastOpen)}
                        style={positionStyles}
                    >
                        {type === 'success' && <Icon iconName="isChecked" />}
                        {type === 'error' && <Icon iconName="cross" fill="#EC3030" />}
                        <span className={cls.toastContent}>{text}</span>
                    </div>
                )}
            />
        </div>
    );
};
